export default __webpack_public_path__ + "static/asim-hussain-8c75a12e3f719b33d2d338bde8d24a52.jpg";